import { PageDto } from '@asset-metrix/portal-gateway-client-js';

type LinkOptions = {
  slug?: string;
  search?: string;
  pageType?: PageDto['type'];
};

export const pageWithRoleLink = (roleId: string, opts: LinkOptions) => {
  const pathPrefix = opts.pageType === 'detailPage' ? 'dp' : 'p';

  return `/${pathPrefix}/${encodeURIComponent(roleId)}/${opts.slug ?? ''}${opts.search ?? ''}`;
};

export function equalPathname(a: string, b: string): boolean {
  const urlA = new URL(a, 'http://localhost');
  const urlB = new URL(b, 'http://localhost');

  return urlA.pathname === urlB.pathname;
}
